import type { SupabaseClient } from '@supabase/supabase-js';
import {
  parseLiveActivityFacts,
  projectLiveActivity,
  type LiveActivityRow,
} from '@brunel/shared';

const UNKNOWN_ACTIVITY: readonly LiveActivityRow[] = [{
  actorKey: 'live-activity',
  actorKind: 'overseer',
  actorLabel: 'Live Activity',
  state: 'UNKNOWN',
  action: 'current activity could not be read',
  since: null,
  source: 'live_activity_facts',
  refs: {},
}];

function record(value: unknown): Record<string, unknown> | null {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
    ? value as Record<string, unknown>
    : null;
}

/** One read-only projection. Failure stays visible as Unknown and never falls back to logs. */
export async function loadLiveActivity(
  client: SupabaseClient,
  orgId: string,
): Promise<readonly LiveActivityRow[]> {
  const response = await client.rpc('live_activity_facts', { request: { orgId } });
  if (response.error) return UNKNOWN_ACTIVITY;
  const envelope = record(response.data);
  const facts = envelope?.['ok'] === true ? parseLiveActivityFacts(envelope['value']) : null;
  return facts === null ? UNKNOWN_ACTIVITY : projectLiveActivity(facts);
}
